// components/PitchDeck/05_MarketOpportunity.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function MarketOpportunity() {
    return (
        <div className="min-h-screen flex items-center bg-white py-20">
            <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    Massive Market Opportunity
                </h2>
                <p className="text-3xl font-semibold text-[#4285F4] mb-8">
                    Nigeria: 35–39 Million MSMEs
                </p>
                <div className="grid md:grid-cols-2 gap-12">
                    <div>
                        <p className="text-2xl mb-6">Only 10–20% use digital accounting tools</p>
                        <p className="text-xl text-gray-700">Most rely on Excel, manual methods, or basic sales/inventory apps.</p>
                    </div>
                    <div>
                        <p className="text-2xl mb-6">6–12 Million tech-adoptable businesses immediately</p>
                        <p className="text-xl text-gray-700">Rising adoption outside Lagos/Abuja/Port Harcourt.</p>
                    </div>
                </div>
                <div className="mt-16">
                    <p className="text-4xl font-bold text-gray-900">
                        TAM: USD 0.6 – 2.6 Billion
                    </p>
                    <p className="text-2xl mt-6 text-gray-700">
                        At USD 100–200 annual ARPU — huge runway for full-package accounting.
                    </p>
                </div>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/traction-milestones">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}